import React from 'react';

import styles from './styles.module.scss';

import InfoCard from '../../util/info-card/InfoCard';
import { convertMetersToKilometers, moneyLabel } from '@/Utils/FnUtils';
import { paymentMethods } from '@/static/FranchiseConstants';
import type { Place } from '@/_types/places';

interface IProps {
  place: Place;
}

function FaresApplied({ place }: IProps) {
  const { placeFare } = place;

  if (!placeFare) {
    return null;
  }

  return (
    <div className={styles.faresApplied}>
      <h2 className="mgn-bottom-sm">Tarifas aplicadas</h2>

      <div>
        <InfoCard title="Entrega base">
          <div className={styles.line}>
            <span>Distância entrega: </span>
            <span>
              {convertMetersToKilometers(placeFare.entregaBaseMts)} Km
            </span>
          </div>
          <div className={styles.line}>
            <span>Valor: </span>
            <span>{moneyLabel(placeFare.valorEntregaBase)}</span>
          </div>
          <div className={styles.line}>
            <span>Taxa: </span>
            <span>{moneyLabel(placeFare.taxaEntregaBase)}</span>
          </div>
        </InfoCard>

        <InfoCard title="Km Adicional">
          <div className={styles.line}>
            <span>Valor: </span>
            <span>{moneyLabel(placeFare.valorKmAdicional)}</span>
          </div>
          <div className={styles.line}>
            <span>Taxa: </span>
            <span>{moneyLabel(placeFare.taxaEntregaKmAdicional)}</span>
          </div>
        </InfoCard>

        <InfoCard title="Outros parâmetros">
          <div className={styles.line}>
            <small>Dist. limite entre entregas: </small>
            <small>
              {convertMetersToKilometers(placeFare.maxDistanceDropsToGroup)} Km
            </small>
          </div>

          <div className={styles.line}>
            <small>Dist. entregador/estabelec.: </small>
            <small>
              {convertMetersToKilometers(placeFare.raioMaxDistance)} Km
            </small>
          </div>

          <div className={styles.line}>
            <small>Quantidade de entregas: </small>
            <small>
              {convertMetersToKilometers(placeFare.qtdMaxEntregaGroup)} Km
            </small>
          </div>

          <div className={styles.line}>
            <small>Dist. mínima do estabelec.: </small>
            <small>
              {convertMetersToKilometers(placeFare.minDistanceCloseTo || 0)} Km
            </small>
          </div>
        </InfoCard>

        <div>
          <InfoCard title="Obrigatoriedade de retorno">
            <div className={styles.line}>
              <span>
                {placeFare.requiredReturnToConfirmPayMethods
                  .map(paymentMethod => paymentMethods[paymentMethod])
                  .join(' / ')}
              </span>
            </div>
          </InfoCard>

          {/* <InfoCard title="Mensalidade">
            <div className={styles.line}>
              <span>{moneyLabel(placeFare.monthlyPayment)}</span>
            </div>
          </InfoCard> */}
        </div>
      </div>
    </div>
  );
}

export default FaresApplied;
